import { render } from "./RegImgUpload.vue?vue&type=template&id=7086e871"
import script from "./RegImgUpload.vue?vue&type=script&lang=js"
export * from "./RegImgUpload.vue?vue&type=script&lang=js"

import "./RegImgUpload.vue?vue&type=style&index=0&id=7086e871&lang=scss"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian-install-mobile-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__